import { createClient } from '@supabase/supabase-js';

//* production key
// const supabaseUrl = 'https://tjqkubodtkocvmzuswvq.supabase.co';
// const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRqcWt1Ym9kdGtvY3ZtenVzd3ZxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAwNTg2MjMsImV4cCI6MjA2NTYzNDYyM30.mj0oWyGK6CNzKuZpVQmrb33tqSqSduY7H0pz7JdvfAI'

//* paid account
const supabaseUrl = 'https://wdjvktsgboywpucntsof.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndkanZrdHNnYm95d3B1Y250c29mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY5Mzc4MTMsImV4cCI6MjA5MjUxMzgxM30.Y5XNLJtpO2zfioql9zp4nfnaH0DJ9T8FF2FWZoiTUKI'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: false,
    }
});

if (supabase && supabaseAnonKey) {
    console.log('Supabase initialized');
}
else {
    throw new Error('Missing Supabase credentials');
}



export const CareJotAuthUser = async (params: any, token?: string) => {
    const {
        agency_id,
        email_id,
        mobile_number,
        role,
        sso_id,
        first_name,
        last_name,
        uuid,
        rawQueryString,
    } = params;

    try {
        // Extract uuid if coming from query string
        let finalUUID =
            uuid ||
            (rawQueryString &&
                new URLSearchParams(rawQueryString).get("uuid"));

        if (!sso_id) {
            console.error("Missing sso_id — cannot proceed.");
            return null;
        }

        if (!email_id) {
            console.error("Missing email.");
            return null;
        }

        // ✅ Stable password (same as native)
        const stablePassword = `carebravo@2025!`;

        let existingProfile: any = null;

        // ─── Step 1: Check by sso_id ─────────────────────
        const { data: bySSO, error: ssoError } = await supabase
            .from("user_info")
            .select("*")
            .eq("sso_id", sso_id)
            .maybeSingle();

        if (ssoError) console.error("SSO check error:", ssoError);
        else existingProfile = bySSO;

        // ─── Step 2: fallback → email ────────────────────
        if (!existingProfile) {
            const { data: byEmail, error: emailError } = await supabase
                .from("user_info")
                .select("*")
                .eq("email", email_id)
                .maybeSingle();

            if (emailError) console.error("Email check error:", emailError);
            else existingProfile = byEmail;
        }

        let session: any;
        let userId: string;

        // ───────────────── NEW USER ─────────────────
        if (!existingProfile) {
            console.log("No user → Signing up");

            const { data: signupData, error: signupError } =
                await supabase.auth.signUp({
                    email: email_id,
                    password: stablePassword,
                });

            if (signupError) {
                if (signupError.message.includes("User already registered")) {
                    // fallback login
                    const { data: signinData, error: signinError } =
                        await supabase.auth.signInWithPassword({
                            email: email_id,
                            password: stablePassword,
                        });

                    if (signinError) {
                        console.error("Signin failed:", signinError);
                        return null;
                    }

                    session = signinData.session;
                    userId = signinData.user.id;
                } else {
                    console.error("Signup error:", signupError);
                    return null;
                }
            } else {
                session = signupData.session;
                userId = signupData.user?.id || "";
            }

            // Insert profile
            const { error: insertError } = await supabase
                .from("user_info")
                .insert({
                    id: userId,
                    email: email_id,
                    mobile_number,
                    role,
                    sso_id,
                    agency_id: [Number(agency_id)],
                    name: `${last_name} ${first_name}`,
                    uuid: finalUUID,
                    fcm_token: token,
                });

            if (insertError) {
                console.error("Insert error:", insertError);
                return null;
            }

            console.log("✅ New user created");
        }

        // ───────────────── EXISTING USER ─────────────────
        else {
            console.log("Existing user found");

            userId = existingProfile.id;

            let signinData, signinError;

            // Try 1: stable password
            ({ data: signinData, error: signinError } =
                await supabase.auth.signInWithPassword({
                    email: existingProfile.email,
                    password: stablePassword,
                }));

            // Try 2: old email-based password
            if (signinError) {
                ({ data: signinData, error: signinError } =
                    await supabase.auth.signInWithPassword({
                        email: existingProfile.email,
                        password: `CB_${existingProfile.email}_2024!`,
                    }));

                if (!signinError) {
                    await supabase.auth.updateUser({
                        password: stablePassword,
                    });
                }
            }

            // Try 3: first_name fallback
            if (signinError) {
                ({ data: signinData, error: signinError } =
                    await supabase.auth.signInWithPassword({
                        email: existingProfile.email,
                        password: `${first_name}@123`,
                    }));

                if (!signinError) {
                    await supabase.auth.updateUser({
                        password: stablePassword,
                    });
                }
            }

            if (signinError) {
                console.error("❌ All login attempts failed", signinError);
                return null;
            }

            session = signinData.session;

            // Update email if changed
            if (existingProfile.email !== email_id) {
                await supabase.auth.updateUser({
                    email: email_id,
                });
            }

            // Merge agency IDs
            let mergedAgencyIds: number[] = [];
            const newAgencyId = Number(agency_id);
            if (existingProfile.agency_id && Array.isArray(existingProfile.agency_id)) {
                mergedAgencyIds = [...existingProfile.agency_id];
                if (!mergedAgencyIds.includes(newAgencyId)) {
                    mergedAgencyIds.push(newAgencyId);
                }
            } else if (existingProfile.agency_id) {
                const oldAgencyId = Number(existingProfile.agency_id);
                mergedAgencyIds = [oldAgencyId];
                if (oldAgencyId !== newAgencyId) {
                    mergedAgencyIds.push(newAgencyId);
                }
            } else {
                mergedAgencyIds = [newAgencyId];
            }

            // Update profile
            const { error: updateError } = await supabase
                .from("user_info")
                .update({
                    email: email_id,
                    mobile_number,
                    role,
                    agency_id: mergedAgencyIds,
                    uuid: finalUUID,
                    fcm_token: token,
                    name: `${last_name} ${first_name}`,
                    sso_id,
                })
                .eq("id", userId);

            if (updateError) {
                console.error("Update error:", updateError);
                return null;
            }

            console.log("✅ Profile updated");
        }

        // ─── Final fetch ─────────────────────────────
        const { data: userProfile, error: fetchError } =
            await supabase
                .from("user_info")
                .select("*")
                .eq("id", userId)
                .single();

        if (fetchError) {
            console.error("Fetch error:", fetchError);
            return null;
        }

        console.log("🎯 Login success");
        return userProfile;

    } catch (err: any) {
        console.error("Auth failed:", err.message);
        return null;
    }
};

export const MessageAuthUser = CareJotAuthUser;
